<section class="programa" style="margin-top: 5vh;">

  <!-- HEADER -->
  <div class="programa-header">
    <h2>Programa Interno</h2>
    <p>Accede rápidamente a los documentos y trámites</p>
  </div>

  <!-- GRID -->
  <div class="programa-grid">

    <!-- CARD -->
    <a routerLink="/admin/proteccion-civil/pc/interno/ficha-pago" class="programa-card">
      <div class="card-img">
        <img src="https://i.imgur.com/tOD8uaH.png" alt="">
      </div>
      <div class="card-content">
        <h3>Ficha de Pago</h3>
        <span>Descargar →</span>
      </div>
    </a>

    <a href="#" class="programa-card">
      <div class="card-img">
        <img src="https://i.imgur.com/yNJrbbt.png" alt="">
      </div>
      <div class="card-content">
        <h3>Solicitud</h3>
        <span>Descargar →</span>
      </div>
    </a>

    <a href="#" class="programa-card">
      <div class="card-img">
        <img src="https://i.imgur.com/2wpU6Qr.png" alt="">
      </div>
      <div class="card-content">
        <h3>Folio de Trámite</h3>
        <span>Descargar →</span>
      </div>
    </a>

    <a routerLink="/admin/proteccion-civil/tramite/seccion" class="programa-card">
      <div class="card-img">
        <img src="https://i.imgur.com/IxRwexQ.png" alt="">
      </div>
      <div class="card-content">
        <h3>Trámite</h3>
        <span>Ir →</span>
      </div>
    </a>

  </div>

</section>
